module.exports = __webpack_public_path__ + "img/transition.3089cf78.svg";